export class ArtikelRequest {
  public username: string;
  public password: string;
  public shop: string;
  public kondition: string;
}

export class ArtikelResponse {
  public success = false;
  public errorText: string;
  public lieferdatum = "";
  public liefertage: string[] = [];
  public artikel: Artikel[] = null;
  public mindestbestellmenge: number;
  public ehPLage: number;
  public ehPCC: number;
  public nochNichtLieferbareAnzeigen = false;
  public hatSorten: boolean;
  public bestellPos = {};
  public bestellungErlaubt = false;
}

export class WarenkorbRequest {
  public username: string;
  public password: string;
  public shop: string;
  public kondition: string;
  public bestelleinheit: string;
  public multiplikator: number;
  public pos: BestellPos;
}

export class WarenkorbResponse {
  public success = false;
  public errorText: string;
}

export class OrderRequest {
  public username: string;
  public password: string;
  public shop: string;
  public kondition: string;
  public lieferdatum: string;
  public bemerkung: string;
  public bestellnummer: string;
  public pos: BestellPos[];
}

export class OrderResponse {
  public success = false;
  public errorText: string;
  public shop: string;
  public kondition: string;
  public lieferdatum: string;
  public bemerkung: string;
  public warenwert = 0;
  public einheiten = 0;
  public pos: BestellPos[];
}

export class Artikel {
  public id: string;
  public artikelNr: string;
  public artikelGruppe: string;
  public bezeichnung: string;
  public bezeichnung3: string;
  public bildUrl: string;
  public vpe: number;
  public maxEh: number;
  public maxVe: number;
  public maxLg: number;
  public maxLt: number;
  public topfCm: string;
  public hoeheCm: string;
  public vkPreis: number;
  public vkPreisVe: number;
  public vkPreisLg: number;
  public vkPreisCc: number;
  public ean: string;
  public pos: BestellPos;
  public zusatz: string;
  public zusatz2: string;
  public verfuegbar: boolean;
  public verfuegbarAb: string;
  public verfuegbarBis: string;
  public multiplikator: number;
  public multiplikatorVe: number;
  public multiplikatorLg: number;
  public multiplikatorCc: number;
  public bestelleinheit: string;
  public ehPLage: number;
  public lgPCC: number;
  public lieferbarAb: Date;
  public lieferbarBis: Date;
  public lieferbarTermine: Date[];
  public hatSorten: boolean;
  public sorten: Artikel[];
  public sorte: string;
  public topartikel: boolean;
  public preisAnzeigen: boolean;
}

export class BestellPos {
  public id: string;
  public eh = 0;
  public hinweis = "";
  public packhinweis = "";

  constructor(id) {
    this.id = id;
  }
}

export class WarenkorbPos {}
